export default "https://cdn-static.gokick.com/assets/38a17193d7f2ad0638d84ec7199a8f76eb0c19ef/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";